import React, { useContext as useContextCore } from 'react'
import type { File } from '@ztechapps/common.contract'
import type { UseListResult } from '@ztechapps/common.hook'
import { useFileList } from '@ztechapps/common.hook'

export type FileBrowserProviderProps = {
  children: React.ReactNode
}

export type FileBrowserContext = {
  fileListResult: UseListResult<File>
} & Omit<FileBrowserProviderProps, 'children'>

const context = React.createContext<FileBrowserContext>({} as FileBrowserContext)
const CoreProvider = context.Provider

export const FileBrowserProvider = ({ children, ...props }: FileBrowserProviderProps) => {
  const fileListResult = useFileList()

  return <CoreProvider value={{ fileListResult, ...props }}>{children}</CoreProvider>
}

export const useFileBrowserContext = () => useContextCore(context)
